// Ícones
import CheckroomIcon from "@mui/icons-material/Checkroom";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import TvIcon from "@mui/icons-material/Tv";
import LuggageIcon from "@mui/icons-material/Luggage";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import KitchenIcon from "@mui/icons-material/Kitchen";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import ComputerIcon from "@mui/icons-material/Computer";

export const categorias = [
    { nome: "CUPOM ALIMENTOS E BEBIDAS", icon: <FastfoodIcon sx={{ fontSize: 70, color: "#E7BF5B" }} />, slug: 'alimentos-e-bebidas' },
    { nome: "CUPOM ELETRÔNICOS ", icon: <HeadphonesIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug: 'eletronicos' },
    { nome: "CUPOM BELEZA", icon: <FaceRetouchingNaturalIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug: 'beleza' },
    { nome: "CUPOM ESPORTES", icon: <SportsSoccerIcon sx={{ fontSize: 70, color: '#f7ca57' }} />, slug: 'esportes' },
    { nome: "CUPOM INFORMÁTICA", icon: <ComputerIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug: 'informatica' },
    { nome: "CUPOM MODA FEMININA", icon: <CheckroomIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug: 'moda-feminina' },
    { nome: "CUPOM SMARTPHONES", icon: <SmartphoneIcon sx={{ fontSize: 70, color: '#E7BF5B'}} />, slug: 'smartphone-tablet' },
    { nome: "CUPOM TV E ÁUDIO", icon: <TvIcon sx={{ fontSize: 70, color: '#E7BF5B'}} />, slug: 'tv-audio' },
    { nome: "CUPOM VIAGEM", icon: <LuggageIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug: 'viagem' },
    { nome: "CUPOM GAMES", icon: <SportsEsportsIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug:'games' },
    { nome: "CUPOM ELETRODOMÉSTICOS", icon: <KitchenIcon sx={{ fontSize: 70, color: '#E7BF5B' }} />, slug: 'eletrodomesticos' },
];

export const categoriasClubeDoAluno = [
    { nome: "10 Do 10: Cashbacks Especiais por 24H", icon: <FastfoodIcon sx={{ fontSize: 50, color: "#0095FE" }} />, slug: 'oferta-do-dia' },
    // { nome: "Eletrônicos", icon: <HeadphonesIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'eletronicos' },
    // { nome: "Beleza", icon: <FaceRetouchingNaturalIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'beleza' },
    // { nome: "Esportes", icon: <SportsSoccerIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'esportes' },
    // { nome: "Informática", icon: <ComputerIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'informatica' },
    // { nome: "Moda Feminina", icon: <CheckroomIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'moda-masculina' },
    // { nome: "Smartphone", icon: <SmartphoneIcon sx={{ fontSize: 50, color: '#0095FE'}} />, slug: 'smartphone-tablet' },
    // { nome: "TV e Áudio", icon: <TvIcon sx={{ fontSize: 50, color: '#0095FE'}} />, slug: 'tv-audio' },
    // { nome: "Viagem", icon: <LuggageIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'viagem' },
    // { nome: "Games", icon: <SportsEsportsIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug:'games' },
    // { nome: "Eletrodomésticos", icon: <KitchenIcon sx={{ fontSize: 50, color: '#0095FE' }} />, slug: 'eletrodomesticos' },
];

